import { useEffect } from "react";
import Hero from "@/components/Hero";
import Timeline from "@/components/Timeline";
import Career from "@/components/Career";
import WorldAtlas from "@/components/WorldAtlas";
import Cruises from "@/components/Cruises";
import ServiceRecord from "@/components/ServiceRecord";
import Gallery from "@/components/Gallery";
import ChapterDivider from "@/components/ChapterDivider";
import ChapterSpine from "@/components/ChapterSpine";
import useChapterScroll from "@/hooks/useChapterScroll";

export default function Home() {
  useChapterScroll();

  useEffect(() => {
    // Handle hash navigation from other pages
    if (window.location.hash) {
      const id = window.location.hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, []);

  return (
    <main data-testid="home-page">
      <ChapterSpine />
      <Hero />

      <ChapterDivider
        id="chapter-i"
        numeral="I."
        kicker="Chapter One · 1962 — 1978"
        title="The Royal Navy Years"
        lede="From a sixteen-year-old boy entrant at HMS Ganges, through eleven drafts on six ships and three shore establishments, to Chief Petty Officer Mechanician First Class on a nuclear-armed Polaris submarine. Sixteen years of service to the Crown."
      />
      <Timeline />
      <ServiceRecord />
      <Gallery />

      <ChapterDivider
        id="chapter-ii"
        numeral="II."
        kicker="Chapter Two · 1978 — 2014"
        title="A Career in Information"
        lede="Out of the Navy and into Technical Publications at Mark One. Then thirteen years building Offshore Design Ltd's authorship and quality systems in Aberdeen — culminating in BS 5750 accreditation across every department. Then seventeen years as an independent Information Management contractor, taking the same engineering rigour to BP, ARCO and Elf projects across the North Sea, the Gulf of Mexico, Venezuela and Angola."
      />
      <Career />

      <ChapterDivider
        id="chapter-iii"
        numeral="III."
        kicker="Chapter Three · Around the World"
        title="The World, Mapped"
        lede="Every place Dad has been — the ships' ports of call, the consultant assignments that took him to four continents, the family holidays in between, and ten Royal Caribbean cruises with the Crown & Anchor Society. Toggle the layers to see each life laid over the other."
      />
      <WorldAtlas />
      <Cruises />
    </main>
  );
}
